module.exports = __webpack_public_path__ + "img/brand8.d0afddd4.png";